var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.6 36.6",
    style: {
      enableBackground: "new 0 0 42.6 36.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.6,15.2 30.5,15.2 24.4,15.2 18.3,15.2 12.2,15.2 6.1,15.2 0,15.2 0,21.3 6.1,21.3 12.2,21.3   18.3,21.3 24.4,21.3 30.5,21.3 36.6,21.3 36.6,27.4 36.6,30.5 30.5,30.5 24.4,30.5 18.3,30.5 12.2,30.5 6.1,30.5 0,30.5 0,36.6   6.1,36.6 12.2,36.6 18.3,36.6 24.4,36.6 30.5,36.6 36.6,36.6 42.6,36.6 42.6,33.5 42.6,30.5 42.6,27.4 42.6,21.3 42.6,15.2 ",
    fill: "#ffffff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.2,6.1 18.3,6.1 24.4,6.1 24.4,0 18.3,0 12.2,0 6.1,0 0,0 0,6.1 6.1,6.1 ",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMiniLogo);
export default __webpack_public_path__ + "static/media/sidebar-mini-logo.ced6ab42593494a649cda35500d23aba.svg";
export { ForwardRef as ReactComponent };